import React, { useMemo } from "react";
import { Text } from "@salestrak/ui";
import type { ActivityChange } from "../activity-types";

interface AddressChunkProps {
  change: ActivityChange;
}

export function AddressChunk({ change }: AddressChunkProps) {
  const fullText = useMemo(() => {
    const beforeAddressText = change.oldAddress?.wholeAddress ?? "";
    const afterAddressText = change.newAddress?.wholeAddress ?? "";

    const actionText = (() => {
      switch (change.action) {
        case "created":
          return "set";
        case "deleted":
          return "cleared";
        case "updated":
          return "updated";
        default:
          return change.action;
      }
    })();

    let beforeText = "";
    if (change.action === "updated" && beforeAddressText) {
      beforeText = `from ${beforeAddressText}`;
    }

    let afterText = "";
    if (change.action !== "deleted" && afterAddressText) {
      afterText = `to ${afterAddressText}`;
    }

    const resultText =
      beforeText && afterText
        ? `${beforeText} ${afterText}`
        : !beforeText && afterText
          ? afterText
          : "";

    const target = change.target.label ?? "address";
    return resultText
      ? `${actionText} ${target} ${resultText}`
      : `${actionText} ${target}`;
  }, [change]);

  return <Text size="sm">{fullText}</Text>;
}
